/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intro_Region_Caribbean_DescriptionInputs */

const bn_intro_region_caribbean_description = /** @type {(inputs: Intro_Region_Caribbean_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ক্লাস্টারড দ্বীপ এবং উপকূলীয় মেমরি চেক.`)
};

const de_intro_region_caribbean_description = /** @type {(inputs: Intro_Region_Caribbean_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cluster-Inseln und Küstengedächtnisprüfungen.`)
};

const el_intro_region_caribbean_description = /** @type {(inputs: Intro_Region_Caribbean_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Συγκεντρωμένα νησιά και έλεγχοι παράκτιας μνήμης.`)
};

const en_intro_region_caribbean_description = /** @type {(inputs: Intro_Region_Caribbean_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clustered islands and coastal memory checks.`)
};

const es_intro_region_caribbean_description = /** @type {(inputs: Intro_Region_Caribbean_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Islas agrupadas y controles de memoria costera.`)
};

const fr_intro_region_caribbean_description = /** @type {(inputs: Intro_Region_Caribbean_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Îles groupées et exercices de mémoire côtière.`)
};

const hi_intro_region_caribbean_description = /** @type {(inputs: Intro_Region_Caribbean_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संकुलित द्वीप और तटीय स्मृति जाँच।`)
};

const hu_intro_region_caribbean_description = /** @type {(inputs: Intro_Region_Caribbean_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Csoportosított szigetek és part menti memóriaellenőrzések.`)
};

const id_intro_region_caribbean_description = /** @type {(inputs: Intro_Region_Caribbean_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulau-pulau yang terkelompok dan pemeriksaan memori pesisir.`)
};

const it_intro_region_caribbean_description = /** @type {(inputs: Intro_Region_Caribbean_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isole raggruppate e controlli di memoria costieri.`)
};

const ja_intro_region_caribbean_description = /** @type {(inputs: Intro_Region_Caribbean_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密集した島と沿岸の記憶チェック。`)
};

const ko_intro_region_caribbean_description = /** @type {(inputs: Intro_Region_Caribbean_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`군집된 섬과 해안 메모리 검사.`)
};

const nl_intro_region_caribbean_description = /** @type {(inputs: Intro_Region_Caribbean_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geclusterde eilanden en kustgeheugencontroles.`)
};

const pl_intro_region_caribbean_description = /** @type {(inputs: Intro_Region_Caribbean_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skupione wyspy i kontrole pamięci przybrzeżnej.`)
};

const pt_intro_region_caribbean_description = /** @type {(inputs: Intro_Region_Caribbean_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilhas agrupadas e verificações de memória costeira.`)
};

const ru_intro_region_caribbean_description = /** @type {(inputs: Intro_Region_Caribbean_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сгруппированные острова и проверки прибрежной памяти.`)
};

const sv_intro_region_caribbean_description = /** @type {(inputs: Intro_Region_Caribbean_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klustrade öar och kustminneskontroller.`)
};

const tr_intro_region_caribbean_description = /** @type {(inputs: Intro_Region_Caribbean_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kümelenmiş adalar ve kıyı hafızası kontrolleri.`)
};

const uk_intro_region_caribbean_description = /** @type {(inputs: Intro_Region_Caribbean_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Згруповані острови та перевірки пам’яті узбережжя.`)
};

const vi_intro_region_caribbean_description = /** @type {(inputs: Intro_Region_Caribbean_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quần đảo cụm và kiểm tra bộ nhớ ven biển.`)
};

const zh_intro_region_caribbean_description = /** @type {(inputs: Intro_Region_Caribbean_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集群岛屿和沿海记忆检查。`)
};

const zh_hant_intro_region_caribbean_description = /** @type {(inputs: Intro_Region_Caribbean_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`群聚島嶼和沿海記憶檢查。`)
};

/**
* | output |
* | --- |
* | "Clustered islands and coastal memory checks." |
*
* @param {Intro_Region_Caribbean_DescriptionInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const intro_region_caribbean_description = /** @type {((inputs?: Intro_Region_Caribbean_DescriptionInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intro_Region_Caribbean_DescriptionInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_intro_region_caribbean_description(inputs)
	if (locale === "de") return de_intro_region_caribbean_description(inputs)
	if (locale === "el") return el_intro_region_caribbean_description(inputs)
	if (locale === "en") return en_intro_region_caribbean_description(inputs)
	if (locale === "es") return es_intro_region_caribbean_description(inputs)
	if (locale === "fr") return fr_intro_region_caribbean_description(inputs)
	if (locale === "hi") return hi_intro_region_caribbean_description(inputs)
	if (locale === "hu") return hu_intro_region_caribbean_description(inputs)
	if (locale === "id") return id_intro_region_caribbean_description(inputs)
	if (locale === "it") return it_intro_region_caribbean_description(inputs)
	if (locale === "ja") return ja_intro_region_caribbean_description(inputs)
	if (locale === "ko") return ko_intro_region_caribbean_description(inputs)
	if (locale === "nl") return nl_intro_region_caribbean_description(inputs)
	if (locale === "pl") return pl_intro_region_caribbean_description(inputs)
	if (locale === "pt") return pt_intro_region_caribbean_description(inputs)
	if (locale === "ru") return ru_intro_region_caribbean_description(inputs)
	if (locale === "sv") return sv_intro_region_caribbean_description(inputs)
	if (locale === "tr") return tr_intro_region_caribbean_description(inputs)
	if (locale === "uk") return uk_intro_region_caribbean_description(inputs)
	if (locale === "vi") return vi_intro_region_caribbean_description(inputs)
	if (locale === "zh") return zh_intro_region_caribbean_description(inputs)
	return zh_hant_intro_region_caribbean_description(inputs)
});